import { useLang } from "../../i18n/LangContext";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center" aria-hidden="true">
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-5xl italic text-[#1C1917] sm:text-7xl lg:text-8xl">{w}</span>
        <span className="h-3 w-3 shrink-0 rounded-full bg-[#C85A32] sm:h-4 sm:w-4" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
  <section data-testid="editorial-marquee" className="overflow-hidden border-y border-[#E7E2D7] bg-[#F3EFE6] py-10 sm:py-14" aria-label={t.marquee.join(", ")}>
    <div className="marquee-track flex w-max">
      <Row words={t.marquee} />
      <Row words={t.marquee} />
    </div>
  </section>
  );
};
